import { fetchAllImages, fetchFavouriteImages } from './FetchImages/fetchImages'

export {
  fetchAllImages,
  fetchFavouriteImages,
}
